import { render, staticRenderFns } from "./returnBzj.vue?vue&type=template&id=49a93858&"
import script from "./returnBzj.vue?vue&type=script&lang=js&"
export * from "./returnBzj.vue?vue&type=script&lang=js&"
import style0 from "./returnBzj.vue?vue&type=style&index=0&id=49a93858&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports